import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

let initialized = false;

export function initPostHog() {
  if (initialized || !POSTHOG_KEY) return;
  
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  });
  
  initialized = true;
}

export function identifyUser(user) {
  if (!initialized || !user?.id) return;
  
  posthog.identify(user.id, {
    email: user.email,
    name: user.name || user.user_metadata?.name || null,
    role: user.role || null,
    church_id: user.church_id || null,
    church_name: user.church_name || null,
  });
}

export function resetUser() {
  if (!initialized) return;
  posthog.reset();
}

export function trackEvent(event, properties = {}) {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export { posthog };
